import { Row, Col, Card, Table, Modal, message, Spin } from "antd";
import { ReactComponent as Logo } from "../../assets/images/Frame 2147225328.svg";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import styled from "styled-components";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { CALL_API } from "../../Common/api";
import { format, differenceInMinutes, parseISO, subHours } from "date-fns";
import { useLocation } from "react-router-dom";
import { ReactComponent as MapIcon } from "../../assets/images/Group 1000004561.svg";
import MapComponent from "../../Reusablecomponents/MapComponent";
import { TripStatusEnum } from "../../Common/constant";
import { render } from "@testing-library/react";
import dayjs from "dayjs";
import moment from "moment";
import { useSelector } from "react-redux";
import { ReactComponent as EventActive } from "../../assets/images/event-over.svg";
import { ReactComponent as Calendar } from "../../assets/images/calendar.svg";
import { ReactComponent as Clock } from "../../assets/images/clock.svg";
import { ReactComponent as GreenlocationIcon } from "../../assets/livetracking/greenlocationicon.svg";
import { ReactComponent as Line } from "../../assets/images/Line 1.svg";

export const TitleStyle = styled.div`
  div[tabindex="0"] {
    width: 100% !important;
    height: 100vh !important;
  }

  @media (min-width: 320px) and (max-width: 480px) {
    .container_for_header_subtwo {
      display: flex;
      flex-wrap: wrap;
    }
    .container_for_headersub_three {
      display: flex;
      flex-wrap: wrap;
      justify-content: end;
    }
  }

  container_six {
    color: green;
  }
  .conatiner_seven {
    padding-top: 17px;
  }
  .container_five {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    display: block;
    background-color: green;
  }
  .container_five {
    color: green;
  }

  .container_three {
    margin-top: 2%;
  }
  .container_four {
    color: #151515;
    font-size: 1rem;
    font: inter;
    font-weight: 500;
  }
  .container_two > div {
    padding: 15px 5px 5px 15px;
  }
  .container_four {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .container_one {
    display: flex;
    justify-content: space-between;
    padding: 8px 8px 18px 8px;
    align-items: center;
    border-bottom: 1px solid #e7e7ed;
  }
  .container_one label {
    font-family: Inter;
    font-weight: 500;
    font-size: 3rem !important;
  }
  p {
    margin-bottom: 0px;
    font-size: 1rem;
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    color: #3d3d3d;
  }
  .container_Green {
    color: #2c963d;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }
  .container_Orange {
    color: #e4a400;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }
  .container_Red {
    color: #f20000;
    display: flex;
    gap: 5px;
    font-family: Inter;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
  }

  .trackright_logo {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
    flex-direction: column;
    align-items: center;
  }
  .trackright_ai_cargo {
    font-size: 1rem;
    padding: 4px 4px 4px 4px;
  }
  .section_card_one {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .section-card {
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    background-color: #ffffff;
  }
  .items-key {
    position: relative;
    margin-bottom: 20px;
  }
  .Event-card {
    position: relative;
    padding-left: 24px;
  }
  .Event-card-line {
    position: absolute;
    left: 12px;
    top: 30px;
  }
  .Event-card-circle {
    position: absolute;
    left: 2px;
    top: -1px;
  }
  .Event-card-text {
    margin-left: 24px;
  }
  .Event-card-text-bold {
    font-weight: bold;
  }
  .Event-card-text-gray {
    color: #979797;
    font-size: 14px;
  }
  .Event-card-text-flex {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .Event-card-text-flex-calendar {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .Event-card-text-flex-clock {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .Event-card-text-flex-calendar span,
  .Event-card-text-flex-clock span {
    margin-left: 4px;
    color: #979797;
    font-size: 14px;
  }
  .apcontainer_onee {
    width: 100%;
    height: 100%;
  }
  /* 
.mapcontainer_three{
  background-color:green!important;
}
.apcontainer_onee{
  width:100%;
  height:100%;
}
 .mapcontainer_eleven {
    width: 100px !important;
  } */

  /* .mapcontainer_one{
  width: 1500px !important;
height:  100%!important;
} */

  /* @media screen and (min-width: 768px) and (max-width: 1024px) {
    .mapcontainer_two {
      display: flex !important;
      flex-direction: column !important;
    }
    .mapcontainer_one {
      max-width: 100% !important;
      width: 100% !important;
    }
    .mapcontainer_three {
      max-width: 100% !important;
      width: 100% !important;
    }
  } */

  /* @media screen and (min-width: 1025px) and (max-width: 1339px) {
    .mapcontainer_one {
      max-width: 100% !important;
      width: 100% !important;
    }
    .mapcontainer_two {
      display: flex !important;
      flex-direction: column !important;
    }
    .mapcontainer_three {
      max-width: 100% !important;
      width: 100% !important;
    }
  } */
  /* @media screen and (min-width: 1440px) and (max-width: 1980px) {
    .mapcontainer_one {
      max-width: 100% !important;
      width: 100% !important;
    }
    .ant-row {
      flex-wrap: nowrap !important;
    }

    .mapcontainer_three {
      max-width: 100% !important;
      width: 100% !important;
    }
  } */

  .title {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0%;
    width: 205;
    height: 17;
    color: #363636;
  }
  .textcolor {
    color: #363636;
  }
`;

// const stoppageColumns = [
//   {
//     title: "Location",
//     dataIndex: "Location",
//     key: "Location",
//     render: (text) => (
//       <div
//         style={{
//           wordWrap: "break-word",
//           wordBreak: "break-word",
//           whiteSpace: "normal",
//         }}
//       >
//         {text || "-"}
//       </div>
//     ),
//   },
//   {
//     title: "Started",
//     dataIndex: "Started",
//     key: "Started",
//     render: (text) => {
//       if (!text) return "N/A";

//       const parts = text?.split(" ");
//       const date = parts.slice(0, 3).join(" "); // "24th Aug 2024"
//       const time = parts.slice(3).join(" "); // "7:10am"

//       return (
//         <>
//           <p style={{ margin: 0 }}>{date}</p>
//           <p style={{ margin: 0 }}>{time}</p>
//         </>
//       );
//     },
//   },
//   {
//     title: "Ended",
//     dataIndex: "Ended",
//     key: "Ended",
//     render: (text) => {
//       if (!text) return "N/A";

//       const parts = text?.split(" ");
//       const date = parts.slice(0, 3).join(" ");
//       const time = parts.slice(3).join(" ");

//       return (
//         <>
//           <p style={{ margin: 0 }}>{date}</p>
//           <p style={{ margin: 0 }}>{time}</p>
//         </>
//       );
//     },
//   },
//   {
//     title: "Duration (HH:MM)",
//     dataIndex: "Duration",
//     key: "Duration",
//   },
// ];

const breakColumns = [
  {
    title: "Location",
    dataIndex: "FenceName",
    key: "FenceName",
  },
  {
    title: "Started",
    dataIndex: "BreakStartTime",
    key: "BreakStartTime",
    render: (value) =>
      value
        ? moment(value).subtract(3, "hours").format("DD/MM/YYYY HH:mm:ss")
        : "",
  },
  {
    title: "Ended",
    dataIndex: "BreakEndTime",
    key: "BreakEndTime",
    render: (value) =>
      value
        ? moment(value).subtract(3, "hours").format("DD/MM/YYYY HH:mm:ss")
        : "",
  },
  {
    title: "Duration (HH:MM)",
    dataIndex: "DurationMinutes",
    key: "DurationMinutes",
    render: (value) => {
      if (!value && value !== 0) return "-";

      const hours = Math.floor(value / 60);
      const minutes = value % 60;

      const formattedHours = String(hours).padStart(2, "0");
      const formattedMinutes = String(minutes).padStart(2, "0");

      return `${formattedHours}:${formattedMinutes}`;
    },
  },
];

// const DeviaionColumn = [
//   {
//     title: "Location",
//     dataIndex: "Location",
//     key: "Location",
//     render: (text) => (
//       <div
//         style={{
//           wordWrap: "break-word",
//           wordBreak: "break-word",
//           whiteSpace: "normal",
//         }}
//       >
//         {text || "-"}
//       </div>
//     ),
//   },
//   {
//     title: "Started",
//     dataIndex: "Started",
//     key: "Started",
//     render: (text) => {
//       if (!text) return "N/A";

//       const parts = text.split(" ");
//       const date = parts.slice(0, 3).join(" "); // "24th Aug 2024"
//       const time = parts.slice(3).join(" "); // "7:10am"

//       return (
//         <>
//           <p style={{ margin: 0 }}>{date}</p>
//           <p style={{ margin: 0 }}>{time}</p>
//         </>
//       );
//     },
//   },
//   {
//     title: "Ended",
//     dataIndex: "Ended",
//     key: "Ended",
//     render: (text) => {
//       if (!text) return "N/A";

//       const parts = text.split(" ");
//       const date = parts.slice(0, 3).join(" ");
//       const time = parts.slice(3).join(" ");

//       return (
//         <>
//           <p style={{ margin: 0 }}>{date}</p>
//           <p style={{ margin: 0 }}>{time}</p>
//         </>
//       );
//     },
//   },
//   {
//     title: "Duration (HH:MM)",
//     dataIndex: "Duration",
//     key: "Duration",
//   },
// ];
const RouteDeviationData = [
  {
    key: "1",
    Location: "Nagercoil, TamilNadu, 629001, India",
    Started: "24th Aug 2024 7:10am",
    Ended: "24th Aug 2024 7:20am",
    Duration: " 02:35",
  },
  {
    key: "2",
    Location: "Nagercoil, TamilNadu, 629001, India",
    Started: "24th Aug 2024 7:10am",
    Ended: "24th Aug 2024 7:20am",
    Duration: "04:35",
  },
];
const TrackLinkAI = () => {
  const { pathname, search } = useLocation();
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const searchParams = new URLSearchParams(search);
  const tripId = pathname.split("/")[2]; // Gets "731"
  const vehId = searchParams.get("vehId"); // Gets "0"
  const mcId = searchParams.get("mcId"); // Gets "1"
  const shipmentTypeId = searchParams.get("shipmentTypeId"); // Gets "1"
  const [eventData, setEventData] = useState([]);
  const [consignTripData, setConsignTripData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [carbonfootprint, setCarbonfootprint] = useState(null);
  const [arrowicondetails, setArrowicondetails] = useState(null);
  const [routeData, setRouteData] = useState([]);

  useEffect(() => {
    const stored = localStorage.getItem("selectedRecord");
    if (stored) {
      const record = JSON.parse(stored);
      setCarbonfootprint(record?.CarbonFootprint);
    }
  }, []);

  // Replace your current useEffect with this:
  const previousDataRef = useRef(null);
  const [locationCache, setLocationCache] = useState({});

  const tripilinkdetails = useCallback(async () => {
    try {
      const { data } = await CALL_API(
        "GET",
        `ai/queryVehicleById?aTripId=${tripId}`,
      );
      const record = data?.FObject?.[0];

      if (record?.FLatitude && record?.FLongitude) {
        const prev = previousDataRef.current;
        const latDiff = Math.abs((prev?.FLatitude || 0) - record.FLatitude);
        const lngDiff = Math.abs((prev?.FLongitude || 0) - record.FLongitude);

        if (!prev || latDiff > 0.001 || lngDiff > 0.001) {
          const locationKey = `${record.FLatitude.toFixed(
            3,
          )},${record.FLongitude.toFixed(3)}`;

          let locationName = locationCache[locationKey];
          if (!locationName) {
            locationName = await fetchLocation(
              record.FLatitude,
              record.FLongitude,
            );
            setLocationCache((prev) => ({
              ...prev,
              [locationKey]: locationName,
            }));
          }

          const newDetails = { ...record, locationName };
          previousDataRef.current = newDetails;
          setArrowicondetails(newDetails);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }, [tripId]);
  const pollingRef = useRef(null);
  useEffect(() => {
    tripilinkdetails();

    pollingRef.current = setInterval(() => {
      tripilinkdetails();
    }, 5000);

    return () => clearInterval(pollingRef.current);
  }, [tripilinkdetails]);

  const fetchEventTable = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `ai/trackingLink/getEventdetailsAi?aTripId=${tripId}&ShipmentType=${shipmentTypeId}&aVehid=${vehId}&mcId=${mcId}`,
      );
      const hasCompletedEvent = data.some((e) => e.EVTYPE === 16);

      if (hasCompletedEvent) {
        clearInterval(pollingRef.current); //  stop 5 sec polling
        pollingRef.current = null;
      }
      const eventsWithLocation = await Promise.all(
        data.map(async (event) => {
          let locationName = "Unknown Location";

          try {
            if (event?.LAT && event?.LNG) {
              // IMPORTANT: fetchLocation expects (lat, lon) in your code
              locationName = await fetchLocation(event.LAT, event.LNG);
            }
          } catch (err) {
            console.error("Error in fetchLocation:", err);
          }

          return {
            ...event,
            LocationName: locationName, // attach here
          };
        }),
      );
      setEventData(eventsWithLocation);
    } catch (error) {
      console.error("Error fetching event table:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatSecondsToHMS = (timeInSeconds) => {
    const totalSeconds = Number(timeInSeconds) || 0;

    const days = Math.floor(totalSeconds / (24 * 60 * 60));
    const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
    const mins = Math.floor((totalSeconds % (60 * 60)) / 60);

    const parts = [];

    if (days > 0) {
      parts.push(`${days} ${days === 1 ? "day" : "days"}`);
      parts.push(
        `${String(hours).padStart(2, "0")} ${hours === 1 ? "hour" : "hours"}`,
      );
      parts.push(
        `${String(mins).padStart(2, "0")} ${mins === 1 ? "minute" : "minutes"}`,
      );
    } else if (hours > 0) {
      parts.push(
        `${String(hours).padStart(2, "0")} ${hours === 1 ? "hour" : "hours"}`,
      );
      parts.push(
        `${String(mins).padStart(2, "0")} ${mins === 1 ? "minute" : "minutes"}`,
      );
    } else {
      // Only minutes if no hours or days
      parts.push(
        `${String(mins).padStart(2, "0")} ${mins === 1 ? "minute" : "minutes"}`,
      );
    }

    return parts.join(" ");
  };

  const fetchLocation = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow`,
      );

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }

      const data = await response.json();

      return data?.features?.[0]?.place_name || "Unknown Location";
    } catch (error) {
      console.error("Error fetching location:", error);
      return "Unknown Location";
    }
  };

  const fetchTripConsignData = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `ai/trackingLink/getTripConsignDetails?aTripId=${tripId}&aVehid=${vehId}&ShipmentType=${shipmentTypeId}&mcId=${mcId}`,
      );
      // Enrich with location names using Mapbox
      const enrichedData = await Promise.all(
        data.map(async (record) => {
          let lastLocationName = "Unknown Location";
          let destinationName = "Unknown Destination";

          // last known location
          if (record.Lastlocation) {
            const [latStr, lonStr] = record.Lastlocation.split(",");
            const lat = parseFloat(latStr);
            const lon = parseFloat(lonStr);
            lastLocationName = await fetchLocation(lat, lon);
          }

          // destination (EndLat/EndLng)
          if (record.EndLat && record.EndLng) {
            const lat = parseFloat(record.EndLat);
            const lon = parseFloat(record.EndLng);
            destinationName = await fetchLocation(lat, lon);
          }

          return {
            ...record,
            LastlocationName: lastLocationName,
            DestinationName: destinationName,
          };
        }),
      );

      setConsignTripData(enrichedData);
    } catch (error) {
      console.error("Error in fetchTripConsignData:", error);
      setConsignTripData([]);
    }
    setLoading(false);
  };

  const [timeandDist, setTimeandDist] = useState([]);

  const [breakData, setBreakData] = useState([]);

  const fetchTimeandDistance = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `ai/getAITransportationReport?aTripId=${tripId}&mcId=${mcId}`,
      );
      setTimeandDist(data);
    } catch (error) {
      console.error("[fetchTripInfoList] error:", error);
      message.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchBreaks = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", `ai/trackingLink/getAIBreaks`, {
        tripId: tripId,
        mcId: mcId,
      });
      setBreakData(data?.breaks || []);
    } catch (error) {
      console.error("[fetchTripInfoList] error:", error);
      message.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  }, []);

  const handleKPIAlerts = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", `AIkpi/handleKPIAlerts`);
    } catch (error) {
      console.error("[handleKPIAlerts] error:", error);
      message.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchPlannedRoutes = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API(
        "GET",
        `ai/fetchRoutesByTripId?tripId=${tripId}`,
      );
      setRouteData(data);
    } catch (error) {
      console.error("[fetchRoutes] error:", error);
      message.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchPlannedRoutes();
  }, []);
  useEffect(() => {
    // run once on page load
    fetchTimeandDistance();
    fetchEventTable();
    fetchBreaks();
    fetchTripConsignData();
    // handleKPIAlerts(); // initial call (optional)

    // const interval = setInterval(
    //   () => {
    //     handleKPIAlerts();
    //   },
    //   0.5 * 60 * 1000,
    // ); // 3 minutes

    // return () => clearInterval(interval); // cleanup on unmount
  }, []);

  // Handlers for modal
  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  function convertToKenyaTimeISO(dateInput) {
    const date = new Date(dateInput);
    if (isNaN(date.getTime())) {
      return "Invalid date";
    }

    const options = { timeZone: "Africa/Nairobi" };
    const year = new Intl.DateTimeFormat("en-GB", {
      ...options,
      year: "numeric",
    }).format(date);
    const month = new Intl.DateTimeFormat("en-GB", {
      ...options,
      month: "2-digit",
    }).format(date);
    const day = new Intl.DateTimeFormat("en-GB", {
      ...options,
      day: "2-digit",
    }).format(date);
    const hour = new Intl.DateTimeFormat("en-GB", {
      ...options,
      hour: "2-digit",
      hour12: false,
    }).format(date);
    const minute = new Intl.DateTimeFormat("en-GB", {
      ...options,
      minute: "2-digit",
    }).format(date);
    const second = new Intl.DateTimeFormat("en-GB", {
      ...options,
      second: "2-digit",
    }).format(date);

    return `${year}-${month}-${day}-${hour}:${minute}:${second}`;
  }
  const consignColumns = [
    {
      title: "Consign Code",
      dataIndex: "CODE",
      key: "CODE",
    },
    {
      title: "Consignor",
      dataIndex: "ConsignorName",
      key: "ConsignorName",
    },
    {
      title: "Consignee",
      dataIndex: "FNAME",
      key: "FNAME",
    },
    {
      title: "Transporter",
      dataIndex: "Transporter",
      key: "Transporter",
    },
    {
      title: "Event Status",
      dataIndex: "EventStatus",
      key: "EventStatus",
      render: (text) => {
        // const event = EventType?.find((item) => item.value === text);
        // const eventName = event?.name || "-";
        // return (
        //     <span>{`${eventName}`}</span>
        // );
        return <span>{text}</span>;
      },
    },
  ];
  const eventColumns = [
    {
      title: "Event",
      dataIndex: "EventName",
      key: "EventName",
      render: (text, record) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <MapIcon
              style={{ width: "20px", height: "20px", cursor: "pointer" }}
              onClick={() => {
                handleOpenModal();
                let rec2 = {
                  ConsigneeId: record.ConsigneeId,
                  ConsigneeName: record.ConsigneeName,
                  EVID: record.EVID,
                  EVTYPE: record.EVTYPE,
                  EventName: record.EventName,
                  Lat: record.LAT,
                  Lng: record.LNG,
                  MODON: record.MODON,
                  TripId: record.TripId,
                  Username: record.Username,
                  LocationName: record.LocationName,
                };

                setSelectedRecord(rec2);
              }}
            />
            <span>{text}</span>
          </div>
        );
      },
      // render: (text, record) => {
      //   const event = EventType?.find((item) => item.value === text);
      //   const eventName = event?.name || "-";
      //   return (
      //     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      //       <MapIcon
      //         style={{ width: "20px", height: "20px", cursor: "pointer" }}
      //         onClick={() => {handleOpenModal();setSelectedRecord(record)}}
      //       />
      //       <span>{`${eventName} - ${record.Code || "N/A"}`}</span>
      //     </div>
      //   );
      // },
    },
    {
      title: "Consignee",
      dataIndex: "FENCENAME",
      key: "FENCENAME",
      render: (text, record) => record.FENCENAME || record.ConsigneeName,
    },
    {
      title: "Updated by",
      dataIndex: "Username",
      key: "Username",
      render: (text, record) => {
        return (
          <>
            <p>TrackRight AI</p>
            <p>
              {record?.MODON
                ? moment(record.MODON)
                    .subtract(3, "hours")
                    .format("Do MMM YYYY; hh:mm A")
                : "-"}
            </p>
          </>
        );
      },
    },
  ];
  const handleclicklogo = () => {
    window.open("https://trackright.africa/", "_blank");
  };

  const formattedTime = (dateString) => {
    return dayjs(dateString).format("YYYY-MM-DD HH:mm:ss");
  };

  return (
    <>
      <TitleStyle>
        <div
          onClick={handleclicklogo}
          style={{
            borderRadius: "8px",
            padding: "16px",
            marginBottom: "24px",
            textAlign: "center",
            backgroundColor: "#ffffff",
            cursor: "pointer",
          }}
        >
          <Logo
            style={{
              width: "129.06866455078125",
              height: "24px",
              marginBottom: "8px",
            }}
          />
          <p className="title">(Live Consignment Tracking)</p>
        </div>

        <Row gutter={16} className="mapcontainer_two">
          {/* Left Column */}
          <Col xs={24} xxl={14} xl={14} md={14} className="mapcontainer_three">
            <div className="section-card">
              <div className="apcontainer_onee">
                <MapComponent
                  className="mapcontainer_eleven"
                  trackLink={false}
                  status={consignTripData?.[0]?.STATUS}
                  containerDetailMap={arrowicondetails}
                  locationsTLAI={eventData}
                  containerplanedRoutes={routeData}
                  actualLocationsAI={consignTripData}
                  timeandDistAI={timeandDist}
                  trackLinktruckicon={true}
                  LocationName={eventData}
                />
              </div>
            </div>
            <Card style={{ marginTop: "20px" }} title="Consignments">
              <StyledTable
                columns={consignColumns}
                dataSource={consignTripData}
                pagination={false}
              />
            </Card>
          </Col>

          {/* Right Column */}
          <Col
            xs={24}
            md={10}
            // className="mapcontainer_one"
          >
            <Card
              title={`Trip Code : ${consignTripData[0]?.TripCode || "N/A"}`}
              extra={
                <span>
                  Status ●{" "}
                  <span
                    style={{
                      color:
                        consignTripData[0]?.STATUS === 0 ||
                        consignTripData[0]?.STATUS === 3
                          ? "#E4A400"
                          : "#008000",
                    }}
                  >
                    {TripStatusEnum.find(
                      (item) => item.value === consignTripData[0]?.STATUS,
                    )?.label || "-"}
                  </span>
                </span>
              }
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  rowGap: 12,
                  gridAutoRows: "min-content",
                }}
              >
                {/* {summaryData.map((item, index) => (
                  <div key={index}>
                    <strong>{item.label}</strong>
                    <div>{item.value}</div>
                  </div>
                ))} */}
                <div>
                  <strong className="textcolor">Driver Name</strong>
                  <div>{timeandDist[0]?.FDriverName || "-"}</div>
                </div>
                <div>
                  <strong className="textcolor">Vehicle</strong>
                  <div>{consignTripData[0]?.VEHREGNO || "-"}</div>
                </div>
                <div>
                  <strong className="textcolor">Carbon Footprint</strong>
                  <div>
                    {(consignTripData[0]?.CarbonFootPrint || 0) + " KgCO₂"}
                  </div>
                </div>

                <div>
                  <strong className="textcolor">Trip ETA</strong>
                  <div>
                    {timeandDist?.[0]?.FPlanEndTime
                      ? dayjs(timeandDist[0].FPlanEndTime).format(
                          "DD/MM/YYYY HH:mm",
                        ) // 24-hour format
                      : "-"}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Break Time</strong>
                  <div>-</div>
                </div>
                <div>
                  <strong className="textcolor">Last Location</strong>
                  <div>
                    {(() => {
                      const location =
                        consignTripData[0]?.LastlocationName || "";
                      const parts = location.split(",");
                      // join the first with the second, then keep the rest as-is
                      if (parts.length > 1) {
                        return `${parts[0]} ${parts[1]}, ${parts
                          .slice(2)
                          .join(",")}`;
                      }
                      return location; // fallback if no comma exists
                    })()}
                  </div>
                </div>

                <div>
                  <strong className="textcolor">Destination Location</strong>
                  <div>
                    {(() => {
                      const location =
                        consignTripData[0]?.DestinationName || "";
                      const parts = location.split(",");
                      // join the first with the second, then keep the rest as-is
                      if (parts.length > 1) {
                        return `${parts[0]} ${parts[1]}, ${parts
                          .slice(2)
                          .join(",")}`;
                      }
                      return location; // fallback if no comma exists
                    })()}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Total Trip Time</strong>
                  <div>
                    {formatSecondsToHMS(timeandDist?.[0]?.TransportationTime) ||
                      "0 s"}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Distance Covered</strong>
                  <div>
                    {(timeandDist?.[0]?.TransportationMileage ?? 0) + " Kms"}
                  </div>
                </div>
                <div>
                  <strong className="textcolor">Container No</strong>
                  <div>{consignTripData?.[0]?.ContainerNo || "-"}</div>
                </div>
              </div>
            </Card>

            {/* <Card title="Consign Code - 23123" style={{ marginTop: 16 }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                rowGap: 12,
              }}
            >
              {consignData.map((item, index) => (
                <div key={index}>
                  <strong>{item.label}</strong>
                  <div>{item.value}</div>
                </div>
              ))}
            </div>
          </Card> */}

            {/* <Card title="Stoppage" style={{ marginTop: 16 }}>
              <StyledTable
                columns={stoppageColumns}
                dataSource={StoppageData}
                pagination={false}
              />
            </Card> */}
            <Card title="Trip Break(s)" style={{ marginTop: 16 }}>
              <StyledTable
                columns={breakColumns}
                dataSource={breakData}
                pagination={false}
              />
            </Card>
            {window.innerWidth >= 320 && window.innerWidth <= 480 ? (
              <Card title={`Events • ${Number() === 1 ? "Import" : "Export"}`}>
                <div className="Event-card">
                  {eventData.map((item, index) => (
                    <div
                      key={item.key}
                      className="items-key"
                      onClick={() => {
                        setSelectedRecord(item);
                        setIsModalVisible(true);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {/* Vertical Line SVG */}
                      {index !== eventData.length - 1 && (
                        <div className="Event-card-line">
                          <Line />
                        </div>
                      )}

                      {/* Circle Icon SVG */}
                      <div className="Event-card-circle">
                        <MapIcon
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                        />
                      </div>

                      {/* Event Details */}
                      <div className="Event-card-text">
                        <div className="Event-card-text-bold">
                          {item.EventName}
                        </div>
                        <div className="Event-card-text-gray">
                          <div className="Event-card-text-bold">
                            {item.ConsigneeName}
                          </div>
                          {/* <div className="Event-card-text-flex-calendar">
                                               <Calendar />
                                               <span>{}</span>
                                             </div> */}
                          <div className="Event-card-text-flex-clock">
                            <Clock />
                            <span>{formattedTime(item?.MODON)}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            ) : (
              <Card title="Events" style={{ marginTop: 16 }}>
                <StyledTable
                  columns={eventColumns}
                  dataSource={eventData}
                  pagination={false}
                />
              </Card>
            )}
          </Col>
        </Row>
      </TitleStyle>
      <Modal
        title="Event Location"
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "10px",
            marginBottom: "16px",
          }}
        >
          <MapComponent
            className="maploca_"
            locationsTL={[selectedRecord]}
            triprackAI={true}
            isminimap={true}
            eventnames={selectedRecord?.EventName}
            locationName={selectedRecord?.LocationName}
            driverName={timeandDist[0]?.FDriverName}
          />
          {/* Map Placeholder */}
        </div>
      </Modal>
    </>
  );
};

export default TrackLinkAI;
